import { formatDateOnly } from '../../../../lib/formatDate';
import type { PersonnelSurveyAnswer } from '../personnelTypes';

export interface SurveyFollowUp {
  label: string;
  value: string;
  mono?: boolean;
}

/**
 * The follow-ups this answer actually carries, in the order the form asks them.
 *
 * `mono` says the value came from a machine rather than from a person — a date and an ID number
 * do, the details and the case status do not.
 *
 * Shared by the Survey panel and the PDS, which draw the same answer: two copies would be two
 * opinions about which follow-ups an answer has.
 */
export function surveyFollowUps(answer: PersonnelSurveyAnswer): SurveyFollowUp[] {
  const lines: SurveyFollowUp[] = [];

  if (answer.details) lines.push({ label: 'Details', value: answer.details });

  // A calendar date — the day a case was filed, not an instant.
  if (answer.dateFiled) {
    lines.push({ label: 'Date filed', value: formatDateOnly(answer.dateFiled), mono: true });
  }

  if (answer.caseStatus) lines.push({ label: 'Status of case', value: answer.caseStatus });
  if (answer.idNumber) lines.push({ label: 'ID no.', value: answer.idNumber, mono: true });

  // Resolved from the country catalog on every read, never stored on the answer.
  if (answer.countryName) lines.push({ label: 'Country', value: answer.countryName });

  return lines;
}
